import { MW_5_10_0 } from '@rsos/reduxDataStore/src/constants/migrationVersions';

const EMERGENCYCALLS = 'emergencyCalls';
/**
 * Migration function that takes a version number and returns the new state for the release
 * @param {Object} state - state
 * @param {String} reducer - which reducer needs a migration
 * @param {Number} version - version number that maps to the migration version number
 */
export const runMigration = (state, reducer, version) => {
  switch (reducer) {
    case EMERGENCYCALLS: {
      if (version === MW_5_10_0) {
        return getStateForMwFiveTenZero(state, reducer);
      }
      return state;
    }
  }
};

const getStateForMwFiveTenZero = (state, reducerName) => {
  if (reducerName === EMERGENCYCALLS) {
    const callQueue = state.callQueue;

    const newCallQueue = Object.keys(callQueue).reduce((acc, caller_id) => {
      const call = callQueue[caller_id];
      acc[caller_id] = call;
      const newCall = { ...call };
      if (
        !newCall.workstationPositions ||
        !Array.isArray(newCall.workstationPositions)
      ) {
        newCall.workstationPositions = [];
        acc[caller_id] = newCall;
      }
      return acc;
    }, {});

    return {
      ...state,
      callQueue: newCallQueue,
    };
  }
};
